import React from 'react';
import { Full } from '../../layout/Full/Full';
import { LoginFormInPro } from './LoginFormInPro';
import { RelativeCenter } from '../../layout/RelativeCenter/RelativeCenter';

export const LoginInPro = () => {
    return (
        <Full hasImg hasWindowHeight>
            <RelativeCenter>
                <LoginFormInPro />
            </RelativeCenter>
        </Full>
    );
};
